"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store");
var variant_1 = require("../variant");
var queryFunctions_1 = require("./queryFunctions");
var hooks_1 = require("../../hooks");
var defaultStoreValue = {
    variant: { status: variant_1.Status.Unknown },
    metadata: {},
};
var depArrayEquality = function (prev, next) {
    if (prev === next) {
        return true;
    }
    if (!prev || !next || prev.length !== next.length) {
        return false;
    }
    return prev.every(function (prevDep, idx) {
        var nextDep = next[idx];
        return (prevDep.dependencyKey === nextDep.dependencyKey &&
            prevDep.dependencyRef === nextDep.dependencyRef &&
            prevDep.currentState === nextDep.currentState);
    });
};
// NOTE: we use the term "dependencies" here because it maps to existing connector HOC
// and terminology used in that API.  Since many core methods are shared with the HOC,
// we've retained the naming conventions where applicable to the shared functionality.
// at a point where the HOC is either gone or refactored, then it would make sense to change
// the naming convention to fit the useQuery interfaces better.
var useCurrentDependencies = function (method, options) {
    var dependencies = store_1.useMappedStoreState(function (get) {
        var methodArray = Array.isArray(method) ? method : [method];
        return methodArray.reduce(function (acc, method) {
            var dependencies = (options.args || []).map(function (args) {
                var dependencyKey = queryFunctions_1.createDependencyString(method, {
                    args: args,
                    fetchAllPages: options.fetchAllPages,
                });
                var dependency = {
                    dependencyKey: dependencyKey,
                    dependencyRef: method,
                    currentState: get(dependencyKey) ||
                        defaultStoreValue,
                    options: __assign(__assign({}, options), { args: args }),
                };
                return dependency;
            });
            return acc.concat(dependencies);
        }, []);
    }, depArrayEquality);
    return hooks_1.useMemoizedObject(dependencies, depArrayEquality);
};
exports.default = useCurrentDependencies;
//# sourceMappingURL=useCurrentDependencies.js.map